// Fallback baseline entries (used if API is unreachable).
// The live source of truth is GET /api/journal/entries.
import { IMG } from "@/lib/images";

export const JOURNAL_FALLBACK = [
  { id: "idea", slug: "idea", tag: "ENTRY 01", date_label: "The Idea", title: "Frustration on a long ride.", body: "It started on a long ride when nothing worked. Wrong bag. Wrong fit. Wrong everything. By the time I got home I had a list — and a problem worth solving.", image_url: IMG.FRUSTRATION_JOHN, object_pos: "60% 30%", published_at: "2026-02-12T00:00:00+00:00" },
  { id: "sketches", slug: "sketches", tag: "ENTRY 02", date_label: "Sketches", title: "Pen, paper, problems first.", body: "Before mood-boards and renders, I sat down with pen and paper. Every pocket had to earn its place. Every strap had to solve a real moment from the saddle.", image_url: IMG.GREECE_SKETCH, object_pos: "50% 35%", published_at: "2026-03-04T00:00:00+00:00" },
  { id: "design", slug: "design", tag: "ENTRY 03", date_label: "Design Development", title: "I don't always test bags… but when I do, I overpack them and go for a ride.", body: "Every prototype gets loaded with real gear and taken on real rides. If it doesn't survive the ride… it doesn't make the cut.", image_url: IMG.STORY_PANELS, object_pos: "50% 18%", published_at: "2026-04-09T00:00:00+00:00" },
  { id: "factory", slug: "factory", tag: "ENTRY 04", date_label: "Factory Partnerships", title: "Finding people who care.", body: "I didn't want the cheapest. I wanted the people who'd argue with me about a stitch. The right partner doesn't say yes to everything. They push back.", image_url: IMG.CAMPAIGN_GRID, object_pos: "50% 50%", published_at: "2026-05-15T00:00:00+00:00" },
  { id: "prototype", slug: "prototype", tag: "ENTRY 05", date_label: "Prototype V1", title: "First real bag.", body: "First real bag in my hands. Heavy moment. Some details landed. Some need work. That's exactly what V1 is for — to fail loudly so V2 can fly.", image_url: IMG.INTERIOR_LOGO, object_pos: "50% 50%", published_at: "2026-06-10T00:00:00+00:00" },
  { id: "road-testing", slug: "road-testing", tag: "ENTRY 06", date_label: "Road Testing", title: "The only review that matters.", body: "Highways. Backroads. Storms. Coffee stops. The Road Glide tells me what's working. The bag has to earn its place on every ride — or it doesn't ship.", image_url: IMG.RIDE_COAST, video_url: IMG.VIDEO_BIKE_TEST, object_pos: "50% 45%", published_at: "2026-06-25T00:00:00+00:00" },
];

let cached = null;
let cachedAt = 0;
const CACHE_MS = 30_000;

export const fetchJournalEntries = async () => {
  const now = Date.now();
  if (cached && now - cachedAt < CACHE_MS) return cached;
  try {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/journal/entries`;
    const res = await fetch(url, { headers: { "Content-Type": "application/json" } });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    if (Array.isArray(data) && data.length) {
      cached = data;
      cachedAt = now;
      return data;
    }
  } catch (_err) {
    // fallthrough to fallback
  }
  return JOURNAL_FALLBACK;
};

export const sortNewestFirst = (entries) =>
  [...entries].sort((a, b) => (a.published_at < b.published_at ? 1 : -1));

export const sortOldestFirst = (entries) =>
  [...entries].sort((a, b) => (a.published_at < b.published_at ? -1 : 1));
